export type GlobalEventStatus = 'proximamente' | 'hoy' | 'finalizado';

export type GlobalEventCategory = 'musica' | 'deportes' | 'comunidad' | 'cultural' | 'religioso' | 'familiar' | 'educativo';

export type GlobalEventModality = 'presencial' | 'online' | 'hibrido';

export interface GlobalEvent {
  id: number;
  stationId: number;
  stationName: string;
  stationFrequency: string;
  stationLogoUrl: string;
  title: string;
  date: string;
  time: string;
  city: string;
  state: string;
  country: string;
  location: string;
  description: string;
  imageUrl: string;
  status: GlobalEventStatus;
  category: GlobalEventCategory;
  modality: GlobalEventModality;
  capacity: number;
  views: number;
  featured: boolean;
}

export const categoryLabels: Record<GlobalEventCategory, string> = {
  musica: 'Música',
  deportes: 'Deportes',
  comunidad: 'Comunidad',
  cultural: 'Cultural',
  religioso: 'Religioso',
  familiar: 'Familiar',
  educativo: 'Educativo',
};

export const categoryIcons: Record<GlobalEventCategory, string> = {
  musica: 'ri-music-2-line',
  deportes: 'ri-football-line',
  comunidad: 'ri-group-line',
  cultural: 'ri-palette-line',
  religioso: 'ri-cross-line',
  familiar: 'ri-hearts-line',
  educativo: 'ri-book-open-line',
};

export const statusLabels: Record<GlobalEventStatus, string> = {
  proximamente: 'Próximamente',
  hoy: 'Hoy',
  finalizado: 'Finalizado',
};

export const statusColors: Record<GlobalEventStatus, string> = {
  hoy: 'bg-red-500 text-background-50',
  proximamente: 'bg-accent-500 text-background-50',
  finalizado: 'bg-foreground-300 text-foreground-700',
};

export const modalityLabels: Record<GlobalEventModality, string> = {
  presencial: 'Presencial',
  online: 'Online',
  hibrido: 'Híbrido',
};

export const modalityIcons: Record<GlobalEventModality, string> = {
  presencial: 'ri-map-pin-line',
  online: 'ri-global-line',
  hibrido: 'ri-smartphone-line',
};

export const modalityColors: Record<GlobalEventModality, string> = {
  presencial: 'bg-amber-50 text-amber-700 border-amber-300',
  online: 'bg-sky-50 text-sky-700 border-sky-300',
  hibrido: 'bg-violet-50 text-violet-700 border-violet-300',
};

export const globalEvents: GlobalEvent[] = [
  // ═══════ RADIO NUEVA ACTITUD (id:1) ═══════
  {
    id: 1,
    stationId: 1,
    stationName: 'Radio Nueva Actitud',
    stationFrequency: '94.70 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20icon%20logo%20design%2C%20circular%20bright%20pop%20music%20theme%2C%20clean%20minimal%20style%2C%20coral%20and%20warm%20tones%2C%20professional%20broadcast%20identity&width=100&height=100&seq=logo-nueva-actitud&orientation=squarish',
    title: 'Festival de Música en el Parque Central',
    date: '2026-07-14',
    time: '14:00 - 22:00',
    city: 'Santa Rosa',
    state: 'California',
    country: 'Estados Unidos',
    location: 'Parque Central, Av. Principal 450, Santa Rosa, CA 95401',
    description: 'Acompáñanos en el festival anual de música del Parque Central. Habrá presentaciones en vivo de 8 bandas locales, food trucks, zona de juegos para niños y transmisión especial desde el escenario principal. Entrada gratuita para toda la familia.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20summer%20music%20festival%20event%20in%20park%2C%20colorful%20vibrant%20stage%20with%20lights%20and%20sound%20equipment%2C%20crowd%20of%20people%20dancing%20and%20enjoying%20live%20music%2C%20food%20trucks%20and%20festival%20tents%20in%20background%2C%20California%20sunny%20day%20atmosphere%2C%20palm%20trees%2C%20festive%20community%20celebration%20photography%20with%20warm%20golden%20hour%20lighting&width=800&height=500&seq=gevent-festival-park-1&orientation=landscape',
    status: 'proximamente',
    category: 'musica',
    modality: 'presencial',
    capacity: 5000,
    views: 4520,
    featured: true,
  },
  {
    id: 2,
    stationId: 1,
    stationName: 'Radio Nueva Actitud',
    stationFrequency: '94.70 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20icon%20logo%20design%2C%20circular%20bright%20pop%20music%20theme%2C%20clean%20minimal%20style%2C%20coral%20and%20warm%20tones%2C%20professional%20broadcast%20identity&width=100&height=100&seq=logo-nueva-actitud&orientation=squarish',
    title: 'Taller de Radio para Jóvenes',
    date: '2026-07-05',
    time: '09:00 - 14:00',
    city: 'Santa Rosa',
    state: 'California',
    country: 'Estados Unidos',
    location: 'Estudios Nueva Actitud, Av. Tecnología 567, Santa Rosa, CA 95403',
    description: 'Aprende cómo se hace radio. Taller gratuito para jóvenes de 14 a 21 años. Conoce el equipo, practica locución y descubre cómo producir tu propio programa. Incluye tour y certificado.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Radio%20production%20workshop%20for%20teenagers%2C%20young%20students%20learning%20at%20broadcast%20studio%20with%20professional%20equipment%2C%20instructor%20demonstrating%20mixing%20console%2C%20educational%20creative%20atmosphere%2C%20modern%20studio%20with%20warm%20lighting%2C%20candid%20learning%20photography&width=800&height=500&seq=gevent-workshop-studio-2&orientation=landscape',
    status: 'proximamente',
    category: 'educativo',
    modality: 'presencial',
    capacity: 30,
    views: 1890,
    featured: false,
  },
  {
    id: 3,
    stationId: 1,
    stationName: 'Radio Nueva Actitud',
    stationFrequency: '94.70 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20icon%20logo%20design%2C%20circular%20bright%20pop%20music%20theme%2C%20clean%20minimal%20style%2C%20coral%20and%20warm%20tones%2C%20professional%20broadcast%20identity&width=100&height=100&seq=logo-nueva-actitud&orientation=squarish',
    title: 'Noche de Karaoke con los Locutores',
    date: '2026-06-08',
    time: '19:00 - 23:00',
    city: 'Santa Rosa',
    state: 'California',
    country: 'Estados Unidos',
    location: 'Bar La Esquina, Calle 7 #234, Santa Rosa, CA 95403',
    description: 'Ven a cantar con nosotros. Noche especial de karaoke donde tú eres la estrella. Premios sorpresa para los mejores cantantes, bebidas 2x1 y transmisión en vivo desde el bar.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Karaoke%20night%20at%20lively%20bar%20venue%2C%20neon%20lights%20and%20stage%20with%20microphone%20stand%2C%20people%20singing%20and%20having%20fun%2C%20colorful%20disco%20lighting%2C%20entertainment%20atmosphere%2C%20warm%20social%20gathering%2C%20candid%20bar%20photography%20with%20vibrant%20energy&width=800&height=500&seq=gevent-karaoke-bar-3&orientation=landscape',
    status: 'hoy',
    category: 'musica',
    modality: 'presencial',
    capacity: 200,
    views: 8700,
    featured: true,
  },
  {
    id: 4,
    stationId: 1,
    stationName: 'Radio Nueva Actitud',
    stationFrequency: '94.70 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20icon%20logo%20design%2C%20circular%20bright%20pop%20music%20theme%2C%20clean%20minimal%20style%2C%20coral%20and%20warm%20tones%2C%20professional%20broadcast%20identity&width=100&height=100&seq=logo-nueva-actitud&orientation=squarish',
    title: 'Concierto Acústico: Sesión Íntima',
    date: '2026-06-01',
    time: '20:00 - 22:30',
    city: 'Santa Rosa',
    state: 'California',
    country: 'Estados Unidos',
    location: 'Teatro Municipal, Calle Cultura 123, Santa Rosa, CA 95404',
    description: 'Una noche mágica de música acústica con artistas locales. Formato íntimo con capacidad limitada a 200 personas. Transmitido en vivo por 94.70 RFW.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20music%20concert%20at%20small%20theater%2C%20singer%20with%20guitar%20on%20dimly%20lit%20stage%2C%20warm%20atmospheric%20spotlight%2C%20audience%20sitting%20in%20cozy%20venue%2C%20cultural%20artistic%20performance%20photography%20with%20moody%20amber%20lighting&width=800&height=500&seq=gevent-acoustic-theater-4&orientation=landscape',
    status: 'finalizado',
    category: 'musica',
    modality: 'presencial',
    capacity: 200,
    views: 12300,
    featured: true,
  },

  // ═══════ RADIO FE Y ESPERANZA (id:2) ═══════
  {
    id: 5,
    stationId: 2,
    stationName: 'Radio Fe y Esperanza',
    stationFrequency: '87.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Faith%20based%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20dove%20and%20cross%20symbolism%2C%20warm%20golden%20tones%2C%20clean%20modern%20religious%20brand%20identity%2C%20peaceful%20aesthetic&width=100&height=100&seq=logo-fe-esperanza&orientation=squarish',
    title: 'Concierto de Alabanza: Noche de Adoración',
    date: '2026-06-08',
    time: '19:00 - 22:00',
    city: 'Miami',
    state: 'Florida',
    country: 'Estados Unidos',
    location: 'Iglesia Comunidad de Fe, 8900 SW 168th St, Palmetto Bay, FL 33157',
    description: 'Noche especial de alabanza y adoración con el Coro Celestial y artistas invitados. Entrada gratuita. Transmisión en vivo por 87.00 RFW para quienes no puedan asistir.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gospel%20worship%20concert%20at%20large%20church%20auditorium%2C%20choir%20singing%20passionately%20on%20stage%2C%20warm%20golden%20lighting%2C%20congregation%20with%20raised%20hands%2C%20spiritual%20uplifting%20atmosphere%2C%20faith%20based%20event%20photography%20with%20ethereal%20light%20beams&width=800&height=500&seq=gevent-worship-miami-5&orientation=landscape',
    status: 'hoy',
    category: 'religioso',
    modality: 'presencial',
    capacity: 800,
    views: 7620,
    featured: true,
  },
  {
    id: 6,
    stationId: 2,
    stationName: 'Radio Fe y Esperanza',
    stationFrequency: '87.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Faith%20based%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20dove%20and%20cross%20symbolism%2C%20warm%20golden%20tones%2C%20clean%20modern%20religious%20brand%20identity%2C%20peaceful%20aesthetic&width=100&height=100&seq=logo-fe-esperanza&orientation=squarish',
    title: 'Retiro Espiritual: Renovación de Fe',
    date: '2026-08-22',
    time: '08:00 - 17:00',
    city: 'Miami',
    state: 'Florida',
    country: 'Estados Unidos',
    location: 'Centro de Retiros Monte Sion, 12000 SW 200th St, Miami, FL 33177',
    description: 'Jornada completa de renovación espiritual con el Pastor Daniel Vega. Incluye sesiones de oración, talleres, almuerzo y transporte desde la iglesia. Cupo limitado a 200 personas.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Spiritual%20retreat%20outdoor%20setting%20with%20peaceful%20natural%20landscape%2C%20people%20gathered%20in%20prayer%20circle%20under%20trees%2C%20serene%20garden%20atmosphere%2C%20warm%20morning%20sunlight%20filtering%20through%20leaves%2C%20calm%20and%20reflective%20community%20gathering%20photography&width=800&height=500&seq=gevent-retreat-miami-6&orientation=landscape',
    status: 'proximamente',
    category: 'religioso',
    modality: 'presencial',
    capacity: 200,
    views: 3420,
    featured: false,
  },
  {
    id: 7,
    stationId: 2,
    stationName: 'Radio Fe y Esperanza',
    stationFrequency: '87.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Faith%20based%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20dove%20and%20cross%20symbolism%2C%20warm%20golden%20tones%2C%20clean%20modern%20religious%20brand%20identity%2C%20peaceful%20aesthetic&width=100&height=100&seq=logo-fe-esperanza&orientation=squarish',
    title: 'Feria de la Familia: Día de la Comunidad',
    date: '2026-05-20',
    time: '10:00 - 16:00',
    city: 'Miami',
    state: 'Florida',
    country: 'Estados Unidos',
    location: 'Parque Tropical, 7900 SW 40th St, Miami, FL 33155',
    description: 'Gran feria familiar con juegos para niños, concursos, música cristiana en vivo y venta de comida. Todo lo recaudado fue destinado a obras de caridad.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Family%20community%20fair%20at%20sunny%20park%2C%20children%20playing%20games%20and%20jumping%20in%20bounce%20houses%2C%20families%20enjoying%20picnic%2C%20colorful%20booths%20and%20tents%2C%20church%20volunteers%20helping%2C%20warm%20community%20celebration%20photography%20with%20bright%20natural%20light&width=800&height=500&seq=gevent-family-fair-miami-7&orientation=landscape',
    status: 'finalizado',
    category: 'familiar',
    modality: 'presencial',
    capacity: 2000,
    views: 9800,
    featured: true,
  },

  // ═══════ LA MEXICANA FM (id:3) ═══════
  {
    id: 8,
    stationId: 3,
    stationName: 'La Mexicana FM',
    stationFrequency: '103.50 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20vibrant%20green%20red%20and%20white%20colors%2C%20traditional%20Mexican%20aesthetic%2C%20bold%20festive%20brand%20identity&width=100&height=100&seq=logo-mexicana-fm&orientation=squarish',
    title: 'Noche de Mariachi en Vivo',
    date: '2026-06-08',
    time: '18:00 - 22:00',
    city: 'Houston',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Salón Los Ángeles, 4520 Hillcroft Ave, Houston, TX 77036',
    description: 'Celebra con nosotros una noche dedicada al mariachi. Presentaciones del Mariachi Sol de México, cena buffet, barra libre de margaritas y transmisión especial por 103.50 RFW.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mariachi%20band%20performing%20live%20at%20elegant%20Mexican%20event%20hall%2C%20musicians%20in%20traditional%20charro%20suits%20with%20embroidered%20details%2C%20warm%20festive%20lighting%2C%20audience%20enjoying%20cultural%20performance%2C%20decorative%20papel%20picado%20banners%2C%20vibrant%20celebration%20photography&width=800&height=500&seq=gevent-mariachi-houston-8&orientation=landscape',
    status: 'hoy',
    category: 'cultural',
    modality: 'presencial',
    capacity: 500,
    views: 9100,
    featured: true,
  },
  {
    id: 9,
    stationId: 3,
    stationName: 'La Mexicana FM',
    stationFrequency: '103.50 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20vibrant%20green%20red%20and%20white%20colors%2C%20traditional%20Mexican%20aesthetic%2C%20bold%20festive%20brand%20identity&width=100&height=100&seq=logo-mexicana-fm&orientation=squarish',
    title: 'Fiesta del Grito: Celebración Patria',
    date: '2026-09-15',
    time: '16:00 - 02:00',
    city: 'Houston',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Plaza México, 6000 Richmond Ave, Houston, TX 77057',
    description: 'La fiesta mexicana más grande de Houston. Música en vivo con banda y norteño, antojitos mexicanos, juegos mecánicos, show de fuegos artificiales y ceremonia del Grito a las 11 PM. Entrada gratuita.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mexican%20Independence%20Day%20outdoor%20fiesta%20celebration%2C%20massive%20crowd%20waving%20flags%2C%20colorful%20stage%20with%20banda%20musicians%20performing%2C%20festive%20lights%20and%20fireworks%2C%20traditional%20Mexican%20atmosphere%2C%20vibrant%20cultural%20festival%20photography%20with%20dramatic%20night%20lighting&width=800&height=500&seq=gevent-grito-houston-9&orientation=landscape',
    status: 'proximamente',
    category: 'cultural',
    modality: 'presencial',
    capacity: 10000,
    views: 15700,
    featured: true,
  },
  {
    id: 10,
    stationId: 3,
    stationName: 'La Mexicana FM',
    stationFrequency: '103.50 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20vibrant%20green%20red%20and%20white%20colors%2C%20traditional%20Mexican%20aesthetic%2C%20bold%20festive%20brand%20identity&width=100&height=100&seq=logo-mexicana-fm&orientation=squarish',
    title: 'Concurso de Talento: Voces de Houston',
    date: '2026-05-28',
    time: '15:00 - 20:00',
    city: 'Houston',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Auditorio Comunitario, 7800 Bissonnet St, Houston, TX 77074',
    description: 'Concurso de canto que reunió a los mejores talentos de la comunidad mexicana en Houston. Premio de $5,000 dólares y la oportunidad de grabar un demo profesional.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20competition%20on%20theater%20stage%2C%20contestants%20performing%20with%20microphones%2C%20judges%20panel%20watching%2C%20colorful%20stage%20lighting%20and%20production%2C%20audience%20clapping%2C%20community%20entertainment%20event%20photography&width=800&height=500&seq=gevent-talent-houston-10&orientation=landscape',
    status: 'finalizado',
    category: 'musica',
    modality: 'presencial',
    capacity: 300,
    views: 13400,
    featured: false,
  },

  // ═══════ ROCK TOTAL RADIO (id:5) ═══════
  {
    id: 11,
    stationId: 5,
    stationName: 'Rock Total Radio',
    stationFrequency: '87.01 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20electric%20guitar%20and%20skull%20motifs%2C%20dark%20edgy%20aesthetic%2C%20bold%20metallic%20tones%2C%20modern%20rock%20brand%20identity&width=100&height=100&seq=logo-rock-total&orientation=squarish',
    title: 'Batalla de Bandas: Edición Verano',
    date: '2026-06-08',
    time: '16:00 - 23:00',
    city: 'Los Ángeles',
    state: 'California',
    country: 'Estados Unidos',
    location: 'The Garage Venue, 4520 Sunset Blvd, Los Angeles, CA 90027',
    description: '10 bandas emergentes compiten por el título de Mejor Banda del Verano. Premio: grabación de EP profesional y rotación en Rock Total por 3 meses. Jurado compuesto por músicos de la escena angelina.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rock%20band%20battle%20competition%20at%20gritty%20underground%20venue%2C%20musicians%20performing%20intensely%20on%20stage%20with%20electric%20guitars%2C%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20energetic%20crowd%20with%20hands%20raised%2C%20raw%20concert%20photography%20with%20moody%20atmospheric%20tones&width=800&height=500&seq=gevent-band-battle-la-11&orientation=landscape',
    status: 'hoy',
    category: 'musica',
    modality: 'presencial',
    capacity: 400,
    views: 11800,
    featured: true,
  },
  {
    id: 12,
    stationId: 5,
    stationName: 'Rock Total Radio',
    stationFrequency: '87.01 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20electric%20guitar%20and%20skull%20motifs%2C%20dark%20edgy%20aesthetic%2C%20bold%20metallic%20tones%2C%20modern%20rock%20brand%20identity&width=100&height=100&seq=logo-rock-total&orientation=squarish',
    title: 'Tributo a Metallica: Master of Puppets',
    date: '2026-07-12',
    time: '20:00 - 01:00',
    city: 'Los Ángeles',
    state: 'California',
    country: 'Estados Unidos',
    location: 'The Roxy Theatre, 9009 Sunset Blvd, West Hollywood, CA 90069',
    description: 'Noche especial de tributo a Metallica. 5 bandas tributo tocando el disco completo más los clásicos. Edición limitada de playeras conmemorativas.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Metallica%20tribute%20concert%20at%20iconic%20rock%20venue%2C%20band%20performing%20with%20intense%20energy%20on%20dimly%20lit%20stage%2C%20dramatic%20blue%20and%20white%20spotlighting%2C%20packed%20crowd%20with%20devil%20horns%20hand%20signs%2C%20heavy%20metal%20concert%20photography%20with%20powerful%20atmosphere&width=800&height=500&seq=gevent-metallica-tribute-12&orientation=landscape',
    status: 'proximamente',
    category: 'musica',
    modality: 'presencial',
    capacity: 500,
    views: 20100,
    featured: true,
  },
  {
    id: 13,
    stationId: 5,
    stationName: 'Rock Total Radio',
    stationFrequency: '87.01 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20electric%20guitar%20and%20skull%20motifs%2C%20dark%20edgy%20aesthetic%2C%20bold%20metallic%20tones%2C%20modern%20rock%20brand%20identity&width=100&height=100&seq=logo-rock-total&orientation=squarish',
    title: 'Rock en el Parque: Festival Gratuito',
    date: '2026-05-15',
    time: '12:00 - 20:00',
    city: 'Los Ángeles',
    state: 'California',
    country: 'Estados Unidos',
    location: 'Griffith Park, 4730 Crystal Springs Dr, Los Angeles, CA 90027',
    description: 'Festival gratuito de rock al aire libre. 15 bandas en 2 escenarios, zona de food trucks, mercado de vinilos y mercancía de bandas locales. Asistencia récord de más de 5,000 personas.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20rock%20music%20festival%20in%20large%20park%20setting%2C%20multiple%20stages%20with%20bands%20performing%2C%20thousands%20of%20people%20on%20grassy%20field%2C%20sunny%20California%20day%2C%20food%20trucks%20and%20vendor%20tents%2C%20massive%20community%20music%20event%20photography%20with%20wide%20angle%20crowd%20shot&width=800&height=500&seq=gevent-rock-park-la-13&orientation=landscape',
    status: 'finalizado',
    category: 'musica',
    modality: 'presencial',
    capacity: 8000,
    views: 25600,
    featured: true,
  },

  // ═══════ DEPORTES TOTAL RADIO (id:7) ═══════
  {
    id: 14,
    stationId: 7,
    stationName: 'Deportes Total Radio',
    stationFrequency: '120.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20football%20and%20star%20motifs%2C%20bold%20energetic%20colors%2C%20dynamic%20sports%20brand%20identity%2C%20professional%20athletic%20aesthetic&width=100&height=100&seq=logo-deportes-total&orientation=squarish',
    title: 'Cobertura en Vivo: Final de Conferencia',
    date: '2026-06-08',
    time: '17:00 - 22:00',
    city: 'Dallas',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Estadio AT&T, 1 AT&T Way, Arlington, TX 76011',
    description: 'Transmisión especial desde el estadio con todo el análisis pre y post partido. Fernando Gutiérrez y La Mesa Redonda en vivo. Invitados especiales y entrevistas exclusivas.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20exterior%20with%20bright%20lights%20and%20massive%20crowd%20entering%20for%20championship%20game%2C%20dramatic%20evening%20sky%2C%20team%20banners%20and%20flags%2C%20professional%20sports%20venue%20atmosphere%2C%20broadcast%20trucks%20and%20media%20setup%20visible%2C%20large%20scale%20event%20photography&width=800&height=500&seq=gevent-stadium-dallas-14&orientation=landscape',
    status: 'hoy',
    category: 'deportes',
    modality: 'presencial',
    capacity: 80000,
    views: 18900,
    featured: true,
  },
  {
    id: 15,
    stationId: 7,
    stationName: 'Deportes Total Radio',
    stationFrequency: '120.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20football%20and%20star%20motifs%2C%20bold%20energetic%20colors%2C%20dynamic%20sports%20brand%20identity%2C%20professional%20athletic%20aesthetic&width=100&height=100&seq=logo-deportes-total&orientation=squarish',
    title: 'Liga de Futbol Radiofrecuencia: Inauguración',
    date: '2026-08-10',
    time: '08:00 - 18:00',
    city: 'Dallas',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Complejo Deportivo Oak Grove, 2525 W Wheatland Rd, Dallas, TX 75237',
    description: 'Arranca la primera Liga de Futbol Radiofrecuencia. 16 equipos amateur, trofeos para los 3 primeros lugares y transmisión de finales en vivo. Inscripciones abiertas.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Amateur%20soccer%20tournament%20at%20sports%20complex%2C%20multiple%20teams%20playing%20on%20green%20fields%2C%20players%20in%20colorful%20jerseys%2C%20referees%20and%20spectators%20around%2C%20sunny%20Texas%20day%2C%20community%20sports%20league%20opening%20day%20photography&width=800&height=500&seq=gevent-soccer-league-dallas-15&orientation=landscape',
    status: 'proximamente',
    category: 'deportes',
    modality: 'presencial',
    capacity: 500,
    views: 6800,
    featured: false,
  },
  {
    id: 16,
    stationId: 7,
    stationName: 'Deportes Total Radio',
    stationFrequency: '120.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20football%20and%20star%20motifs%2C%20bold%20energetic%20colors%2C%20dynamic%20sports%20brand%20identity%2C%20professional%20athletic%20aesthetic&width=100&height=100&seq=logo-deportes-total&orientation=squarish',
    title: 'Encuentro con Leyendas del Deporte',
    date: '2026-06-03',
    time: '18:30 - 21:00',
    city: 'Dallas',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Centro de Convenciones Dallas, 650 S Griffin St, Dallas, TX 75202',
    description: 'Noche de gala con ex estrellas del futbol mexicano y de la NFL. Panel de discusión, sesión de autógrafos, cena incluida y rifa de artículos deportivos firmados.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sports%20legends%20panel%20discussion%20at%20convention%20center%2C%20famous%20retired%20athletes%20on%20stage%20answering%20questions%2C%20large%20audience%20in%20auditorium%2C%20professional%20event%20photography%20with%20stage%20lighting%20and%20sports%20memorabilia%20displays&width=800&height=500&seq=gevent-legends-dallas-16&orientation=landscape',
    status: 'finalizado',
    category: 'deportes',
    modality: 'presencial',
    capacity: 3000,
    views: 16700,
    featured: false,
  },

  // ═══════ NOTICIAS 24/7 RADIO (id:4) ═══════
  {
    id: 17,
    stationId: 4,
    stationName: 'Noticias 24/7 Radio',
    stationFrequency: '107.90 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20globe%20and%20microphone%20motifs%2C%20professional%20blue%20and%20white%20tones%2C%20authoritative%20news%20brand%20identity%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=logo-noticias-247&orientation=squarish',
    title: 'Foro: Libertad de Expresión en la Radio',
    date: '2026-06-28',
    time: '10:00 - 14:00',
    city: 'Nueva York',
    state: 'Nueva York',
    country: 'Estados Unidos',
    location: 'Columbia University, 116th St & Broadway, New York, NY 10027',
    description: 'Foro abierto sobre la libertad de expresión en medios comunitarios. Panelistas internacionales, debates, networking y transmisión en vivo por 107.90 RFW.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Academic%20forum%20panel%20discussion%20at%20university%20auditorium%2C%20speakers%20at%20long%20table%20with%20microphones%2C%20audience%20of%20students%20and%20professionals%2C%20professional%20conference%20atmosphere%2C%20modern%20lecture%20hall%20photography%20with%20natural%20daylight&width=800&height=500&seq=gevent-forum-ny-17&orientation=landscape',
    status: 'proximamente',
    category: 'educativo',
    modality: 'presencial',
    capacity: 300,
    views: 5300,
    featured: false,
  },
  {
    id: 18,
    stationId: 4,
    stationName: 'Noticias 24/7 Radio',
    stationFrequency: '107.90 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20globe%20and%20microphone%20motifs%2C%20professional%20blue%20and%20white%20tones%2C%20authoritative%20news%20brand%20identity%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=logo-noticias-247&orientation=squarish',
    title: 'Cobertura Especial: Elecciones de Medio Término',
    date: '2026-11-04',
    time: '06:00 - 23:59',
    city: 'Nueva York',
    state: 'Nueva York',
    country: 'Estados Unidos',
    location: 'Times Square Studios, 1500 Broadway, New York, NY 10036',
    description: 'Cobertura continua de las elecciones de medio término. Resultados en tiempo real, análisis de expertos, reportes desde todo el país y reacciones en vivo.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Election%20night%20broadcast%20studio%20setup%2C%20large%20screens%20showing%20electoral%20maps%20and%20data%20visualization%2C%20anchors%20at%20professional%20news%20desk%2C%20dramatic%20studio%20lighting%2C%20high-tech%20newsroom%20atmosphere%2C%20major%20event%20media%20coverage%20photography&width=800&height=500&seq=gevent-election-ny-18&orientation=landscape',
    status: 'proximamente',
    category: 'comunidad',
    modality: 'presencial',
    capacity: 2000,
    views: 22300,
    featured: true,
  },

  // ═══════ RADIO COMUNITARIA UNIDA (id:6) ═══════
  {
    id: 19,
    stationId: 6,
    stationName: 'Radio Comunitaria Unida',
    stationFrequency: '87.02 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Community%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20people%20and%20heart%20motifs%2C%20warm%20earthy%20colors%2C%20inclusive%20grassroots%20brand%20identity%2C%20friendly%20welcoming%20aesthetic&width=100&height=100&seq=logo-comunitaria&orientation=squarish',
    title: 'Feria Multicultural de Chicago',
    date: '2026-07-25',
    time: '11:00 - 19:00',
    city: 'Chicago',
    state: 'Illinois',
    country: 'Estados Unidos',
    location: 'Millennium Park, 201 E Randolph St, Chicago, IL 60602',
    description: 'Celebración de la diversidad cultural de Chicago. Música del mundo, danzas tradicionales, gastronomía internacional y stands de organizaciones comunitarias. Transmisión en vivo.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Multicultural%20outdoor%20festival%20at%20city%20park%2C%20diverse%20performers%20on%20stage%20in%20traditional%20costumes%2C%20food%20vendors%20from%20various%20cultures%2C%20families%20enjoying%20summer%20day%2C%20colorful%20decorations%20and%20flags%2C%20vibrant%20community%20celebration%20photography&width=800&height=500&seq=gevent-fair-chicago-19&orientation=landscape',
    status: 'proximamente',
    category: 'cultural',
    modality: 'presencial',
    capacity: 5000,
    views: 4100,
    featured: false,
  },
  {
    id: 20,
    stationId: 6,
    stationName: 'Radio Comunitaria Unida',
    stationFrequency: '87.02 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Community%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20people%20and%20heart%20motifs%2C%20warm%20earthy%20colors%2C%20inclusive%20grassroots%20brand%20identity%2C%20friendly%20welcoming%20aesthetic&width=100&height=100&seq=logo-comunitaria&orientation=squarish',
    title: 'Jornada de Limpieza Comunitaria',
    date: '2026-06-15',
    time: '08:00 - 13:00',
    city: 'Chicago',
    state: 'Illinois',
    country: 'Estados Unidos',
    location: 'Humboldt Park, 1400 N Sacramento Ave, Chicago, IL 60622',
    description: 'Únete a la jornada de limpieza y embellecimiento del parque. Bolsas y herramientas proporcionadas. Al finalizar, habrá almuerzo comunitario y música.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Community%20volunteer%20cleanup%20event%20at%20urban%20park%2C%20diverse%20group%20of%20people%20picking%20up%20litter%20and%20planting%20flowers%2C%20sunny%20morning%20atmosphere%2C%20teamwork%20and%20civic%20pride%2C%20neighborhood%20improvement%20photography%20with%20natural%20light&width=800&height=500&seq=gevent-cleanup-chicago-20&orientation=landscape',
    status: 'proximamente',
    category: 'comunidad',
    modality: 'presencial',
    capacity: 300,
    views: 2800,
    featured: false,
  },

  // ═══════ RADIO INTERNACIONAL VOZ (id:8) ═══════
  {
    id: 21,
    stationId: 8,
    stationName: 'Radio Internacional Voz',
    stationFrequency: '140.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=International%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20globe%20and%20sound%20waves%2C%20cosmopolitan%20blue%20and%20gold%20tones%2C%20global%20broadcast%20brand%20identity%2C%20sophisticated%20modern%20aesthetic&width=100&height=100&seq=logo-internacional&orientation=squarish',
    title: 'Festival de Cine Independiente',
    date: '2026-08-05',
    time: '14:00 - 23:00',
    city: 'San Francisco',
    state: 'California',
    country: 'Estados Unidos',
    location: 'Castro Theatre, 429 Castro St, San Francisco, CA 94114',
    description: 'Muestra de cine independiente internacional. Proyecciones, charlas con directores y ceremonia de premiación. Organizado en colaboración con Radio Internacional Voz.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Independent%20film%20festival%20at%20historic%20theater%2C%20movie%20screen%20with%20arthouse%20film%20screening%2C%20audience%20in%20vintage%20theater%20seats%2C%20artistic%20atmosphere%2C%20cinema%20culture%20event%20photography%20with%20warm%20theatrical%20lighting&width=800&height=500&seq=gevent-film-sf-21&orientation=landscape',
    status: 'proximamente',
    category: 'cultural',
    modality: 'presencial',
    capacity: 1400,
    views: 7600,
    featured: false,
  },

  // ═══════ LA KALLE 99.9 (id:9) ═══════
  {
    id: 22,
    stationId: 9,
    stationName: 'La Kalle 99.9',
    stationFrequency: '99.90 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Urban%20pop%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20energetic%20graffiti%20style%2C%20vibrant%20neon%20colors%2C%20street%20culture%20brand%20identity%2C%20bold%20youthful%20aesthetic&width=100&height=100&seq=logo-la-kalle&orientation=squarish',
    title: 'Block Party: Fiesta de la Calle',
    date: '2026-06-22',
    time: '15:00 - 01:00',
    city: 'Phoenix',
    state: 'Arizona',
    country: 'Estados Unidos',
    location: 'Roosevelt Row, 900 N 1st St, Phoenix, AZ 85004',
    description: 'La fiesta urbana más grande de Phoenix. DJs en vivo, batallas de breakdance, grafiti en vivo, food trucks y mercado de arte local. Entrada gratuita.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Urban%20block%20party%20street%20festival%2C%20DJ%20performing%20on%20outdoor%20stage%2C%20people%20dancing%20on%20closed%20street%2C%20colorful%20murals%20and%20street%20art%20background%2C%20food%20trucks%20and%20vendors%2C%20energetic%20summer%20night%20atmosphere%2C%20vibrant%20youth%20culture%20photography&width=800&height=500&seq=gevent-block-party-phx-22&orientation=landscape',
    status: 'proximamente',
    category: 'musica',
    modality: 'presencial',
    capacity: 3000,
    views: 14100,
    featured: true,
  },

  // ═══════ BANDA RADIO MX (id:12) ═══════
  {
    id: 23,
    stationId: 12,
    stationName: 'Banda Radio MX',
    stationFrequency: '200.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Banda%20music%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20brass%20instruments%20and%20Mexican%20motifs%2C%20bold%20red%20white%20and%20green%20colors%2C%20festive%20regional%20brand%20identity&width=100&height=100&seq=logo-banda-mx&orientation=squarish',
    title: 'Baile Masivo de Banda',
    date: '2026-06-29',
    time: '20:00 - 03:00',
    city: 'San Antonio',
    state: 'Texas',
    country: 'Estados Unidos',
    location: 'Freeman Coliseum, 3201 E Houston St, San Antonio, TX 78219',
    description: 'El baile de banda más grande del año. 5 agrupaciones en vivo, pista de baile gigante, zona VIP y transmisión especial por 200.00 RFW.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Massive%20Mexican%20banda%20music%20dance%20event%20at%20large%20coliseum%2C%20thousands%20of%20people%20dancing%2C%20live%20banda%20group%20on%20stage%20with%20brass%20instruments%2C%20colorful%20concert%20lighting%2C%20energetic%20celebration%20atmosphere%2C%20large%20scale%20event%20photography&width=800&height=500&seq=gevent-baile-sa-23&orientation=landscape',
    status: 'proximamente',
    category: 'musica',
    modality: 'presencial',
    capacity: 6000,
    views: 19200,
    featured: true,
  },

  // ═══════ RADIO VOZ DEL PUEBLO (id:10) ═══════
  {
    id: 24,
    stationId: 10,
    stationName: 'Radio Voz del Pueblo',
    stationFrequency: '160.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Community%20grassroots%20radio%20logo%20design%2C%20circular%20emblem%20with%20microphone%20and%20raised%20fist%2C%20warm%20earthy%20tones%2C%20activist%20brand%20identity%2C%20people%20focused%20aesthetic&width=100&height=100&seq=logo-voz-pueblo&orientation=squarish',
    title: 'Asamblea Comunitaria Abierta',
    date: '2026-07-08',
    time: '17:00 - 20:00',
    city: 'Denver',
    state: 'Colorado',
    country: 'Estados Unidos',
    location: 'Civic Center Park, 101 W 14th Ave, Denver, CO 80204',
    description: 'Asamblea abierta para discutir temas de la comunidad. Micrófono abierto para todos los vecinos. Transmisión en vivo con traducción simultánea al español.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Community%20town%20hall%20meeting%20at%20outdoor%20park%20amphitheater%2C%20diverse%20residents%20speaking%20at%20open%20microphone%2C%20engaged%20audience%20sitting%20on%20grass%2C%20democratic%20participation%20atmosphere%2C%20civic%20engagement%20photography%20with%20afternoon%20sunlight&width=800&height=500&seq=gevent-asamblea-denver-24&orientation=landscape',
    status: 'proximamente',
    category: 'comunidad',
    modality: 'presencial',
    capacity: 500,
    views: 3500,
    featured: false,
  },

  // ═══════ RADIO VIDA NUEVA (id:11) ═══════
  {
    id: 25,
    stationId: 11,
    stationName: 'Radio Vida Nueva',
    stationFrequency: '180.00 RFW',
    stationLogoUrl: 'https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20design%2C%20circular%20emblem%20with%20sunrise%20and%20cross%20motifs%2C%20hopeful%20bright%20tones%2C%20inspirational%20faith%20brand%20identity%2C%20uplifting%20spiritual%20aesthetic&width=100&height=100&seq=logo-vida-nueva&orientation=squarish',
    title: 'Campamento Juvenil de Verano',
    date: '2026-07-18',
    time: '09:00 - 17:00',
    city: 'Orlando',
    state: 'Florida',
    country: 'Estados Unidos',
    location: 'Campo Recreativo Lake Ivanhoe, 4500 N Orange Blossom Trl, Orlando, FL 32804',
    description: 'Campamento de un día para jóvenes de 12 a 18 años. Deportes, talleres creativos, música en vivo, fogata y mensajes inspiradores. Transporte incluido desde la iglesia.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Youth%20summer%20camp%20outdoor%20activities%2C%20teenagers%20playing%20group%20games%20on%20grassy%20field%2C%20bright%20sunny%20Florida%20day%2C%20lake%20in%20background%2C%20joyful%20energetic%20atmosphere%2C%20camp%20counselors%20leading%20activities%2C%20fun%20community%20youth%20event%20photography&width=800&height=500&seq=gevent-camp-orlando-25&orientation=landscape',
    status: 'proximamente',
    category: 'familiar',
    modality: 'presencial',
    capacity: 150,
    views: 5600,
    featured: false,
  },
];

export function getEventsByStatus(status: GlobalEventStatus): GlobalEvent[] {
  return globalEvents.filter((e) => e.status === status);
}

export function getTrendingEvents(): GlobalEvent[] {
  return [...globalEvents].sort((a, b) => b.views - a.views).slice(0, 6);
}

export function getUpcomingEvents(): GlobalEvent[] {
  return [...globalEvents]
    .filter((e) => e.status === 'proximamente')
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
    .slice(0, 6);
}

export function getFeaturedEvents(): GlobalEvent[] {
  return globalEvents.filter((e) => e.featured).slice(0, 6);
}

export function getTodayEvents(): GlobalEvent[] {
  return globalEvents.filter((e) => e.status === 'hoy');
}

export function getPastEvents(): GlobalEvent[] {
  return globalEvents
    .filter((e) => e.status === 'finalizado')
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}